// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Image_imageContainer__Qs3CT","styledImage":"Image_styledImage___dkcA","loader":"Image_loader__15XNL","spinner":"Image_spinner__jw6BP"};